import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const WarningIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 26,
  height = 26,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        data-testid="icon-warning"
        fill="#000000"
        className={styles.defaultColor}
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(0.432125, 1.969228)"
      >
        <path
          d="M13.2032651,0.260304523 C13.5035327,0.430456168 13.7546597,0.675413953 13.9322258,0.971357384 L24.7504798,19.0017808 C25.3187761,19.9489413 25.011646,21.1774618 24.0644855,21.7457581 C23.7536547,21.9322566 23.3979818,22.0307723 23.035494,22.0307723 L2,22.0307723 C0.8954305,22.0307723 -4.26325641e-14,21.1353418 -4.26325641e-14,20.0307723 C-4.26325641e-14,19.685157 0.0895629704,19.3454401 0.259955628,19.0447471 L10.4771955,1.01432375 C11.0217622,0.0533237802 12.2422651,-0.284262127 13.2032651,0.260304523 Z M23.035494,20.0307723 L12.2172399,2.00034889 L2,20.0307723 L23.035494,20.0307723 Z"
          fillRule="nonzero"
        />
        <path
          d="M13.1996437,14.0307723 L13.5678747,7.03077229 L11.5678747,7.03077229 L11.943326,14.0307723 L13.1996437,14.0307723 Z M12.5779757,18.0307723 C12.8922294,18.0307723 13.1357759,17.9400619 13.3086155,17.7586411 C13.481455,17.5772204 13.5678747,17.3313187 13.5678747,17.0209362 C13.5678747,16.7105537 13.4825773,16.4679308 13.3119825,16.2930674 C13.1413876,16.118204 12.8967187,16.0307723 12.5779757,16.0307723 C12.2547434,16.0307723 12.0055852,16.1149253 11.830501,16.2832313 C11.6554168,16.4515373 11.5678747,16.697439 11.5678747,17.0209362 C11.5678747,17.3444335 11.6565391,17.5936138 11.833868,17.7684772 C12.0111968,17.9433406 12.2592327,18.0307723 12.5779757,18.0307723 Z"
          stroke="#000000"
          className={styles.defaultStrokeColor}
        />
      </g>
    </Icon>
  )
}
